module.exports = function(comments) {
	'use strict'
	comments.directive('allCommentsDir',allCommentsDir);
	allCommentsDir.$inject=[];
	function allCommentsDir() {
		return {
			template: require('./partial/allcomments.html'),
			controller:'allcommentsController',
			controllerAs:'vmac',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/allcomments/js/directive/allcommentsDirective.js
// module id = 494
// module chunks = 0